import { IDisplayTableModel } from './display-table-model'

export class LiteratureModel implements IDisplayTableModel {
  portId: string
  fundID: string
  investmentCommentary: string
  invComDate: string
  investmentProfile: string
  invProfDate: string
  factSheet: string
  factSheetDate: string
  summaryVal: string
  prospectus: string
  sai: string
  planParticipant: string
  comparison: string
  comparisonDate: string
  semiAnnualReport: string
  semiAnnualReportDate: string
  annualReport: string
  annualReportDate: string
  ticker: string
  symbol: string
  shortNm: string
  longNm: string
  fundName: string
  profile: any
  reedemptionFeeDisplay: string
  purchaseFeeDisplay: string
  isClosedFund: boolean
  rowId: string

  getFundId(): string {
    return this.portId
  }
}
